module.exports = __webpack_public_path__ + "static/media/score.1d7783a5.svg";